module.exports = __webpack_public_path__ + "static/img/business84.59351dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/business/business84.png
// module id = XMfL
// module chunks = 9